/**
 *  通用插件配置
 */


export function editConfig(options = {}) {
    if(options == undefined) options = {}
   const defaultConfig = {
      placeholder: '请填写说明',
      modules: {
        toolbar: [
          ["bold", "italic", "underline", "strike", "link", "blockquote"],
          [{ 'indent': '-1' }, { 'indent': '+1' }],
          [{ color: [] }, { background: [] }],
          [
            { size: ["small", false, "large", "huge"] },
            { header: [1, 2, 3, 4, 5, 6, false] }
          ],
          [{ list: "ordered" }, { list: "bullet" }],
          [{ align: [] }],
          ["clean"]
        ]
      }
    };
    return {
      ...defaultConfig,
      ...options
    }
}

